import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { installErrorReporter } from "@/lib/errorReporter";

import WhatsAppSimulator from "@/pages/WhatsAppSimulator";
import FriendLanding from "@/pages/FriendLanding";
import AdminLogin from "@/pages/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import PromoPool from "@/pages/admin/PromoPool";
import Referrals from "@/pages/admin/Referrals";
import AdminLeaderboard from "@/pages/admin/Leaderboard";
import FraudQueue from "@/pages/admin/FraudQueue";
import Payouts from "@/pages/admin/Payouts";
import DwhSimulator from "@/pages/admin/DwhSimulator";
import Templates from "@/pages/admin/Templates";
import AuditLog from "@/pages/admin/AuditLog";
import WhatsAppInbox from "@/pages/admin/WhatsAppInbox";
import Scheduler from "@/pages/admin/Scheduler";
import SmokeRunner from "@/pages/admin/SmokeRunner";
import Nps from "@/pages/admin/Nps";
import ProgramConfig from "@/pages/admin/ProgramConfig";
import Alerts from "@/pages/admin/Alerts";
import Contacts from "@/pages/admin/Contacts";
import Incidents from "@/pages/admin/Incidents";
import CsHandoffs from "@/pages/admin/CsHandoffs";
import Help from "@/pages/admin/Help";

installErrorReporter();

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public: friend landing (web). Referrer experience is WhatsApp-only. */}
          <Route path="/r/:slug" element={<FriendLanding />} />
          {/* WhatsApp simulator — for demoing the referrer's WA experience */}
          <Route path="/" element={<WhatsAppSimulator />} />
          <Route path="/wa" element={<WhatsAppSimulator />} />
          {/* Admin console */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<Dashboard />} />
            <Route path="alerts" element={<Alerts />} />
            <Route path="program" element={<ProgramConfig />} />
            <Route path="campaigns" element={<Navigate to="/admin/program" replace />} />
            <Route path="contacts" element={<Contacts />} />
            <Route path="whatsapp" element={<WhatsAppInbox />} />
            <Route path="promo-pool" element={<PromoPool />} />
            <Route path="referrals" element={<Referrals />} />
            <Route path="leaderboard" element={<AdminLeaderboard />} />
            <Route path="fraud" element={<FraudQueue />} />
            <Route path="payouts" element={<Payouts />} />
            <Route path="dwh" element={<DwhSimulator />} />
            <Route path="analytics" element={<Navigate to="/admin" replace />} />
            <Route path="scheduler" element={<Scheduler />} />
            <Route path="nps" element={<Nps />} />
            <Route path="smoke" element={<SmokeRunner />} />
            <Route path="templates" element={<Templates />} />
            <Route path="incidents" element={<Incidents />} />
            <Route path="cs-handoffs" element={<CsHandoffs />} />
            <Route path="audit" element={<AuditLog />} />
            <Route path="help" element={<Help />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
